import moment from "moment";

const formatTrackingNumbers = (packages = []) => {
  const numbers = packages
    .map(
      (pkg) =>
        pkg.package?.package_numbers?.trim() ||
        pkg.waybill_tracking_number?.trim() ||
        "",
    )
    .filter(Boolean);

  return numbers.length > 0 ? numbers.join(", ") : "—";
};

const ReturnItem = ({ item }) => (
  <div className="dashboard m-b-10">
    <header className="dashboard__header">
      <h2 className="dashboard__title heading">
        Zwrot #{item.expano_oms_order_return_id}
      </h2>
    </header>
    <div className="dashboard__list-item">
      <div>
        <p>Utworzono: {moment(item.created_at).format("DD.MM.YYYY HH:mm")}</p>
        <p>
          Numery listów: {formatTrackingNumbers(item.gdn_return_packages)}
        </p>
      </div>
    </div>
    <div className="dashboard__item m-b-15">
      <table className="table">
        <thead className="table__header table-head">
          <tr>
            <th width="150px">SKU</th>
            <th>Nazwa</th>
            <th width="100px">Zadekl.</th>
            <th width="100px">Przyjęto</th>
          </tr>
        </thead>
        <tbody className="table__body table-body">
          {item.gdn_return_lines.map((line) => (
            <tr key={line.id}>
              <td width="150px">{line.sku}</td>
              <td>{line.product?.name || "—"}</td>
              <td>{line.declared_quantity}</td>
              <td>{line.processed_quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default ReturnItem;
